export default __webpack_public_path__ + "static/media/longitPlus.bd518e9e.jpg";